<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-number-input
    v-model="filter.value"
    class="filters-input pb-0"
    clearable
    control-variant="stacked"
    :min="filter.min"
    :max="filter.max"
    :step="filter.step"
    :aria-label="filter.translation || $translate(`${translationName}.${filter.name}`)"
    :label="filter.translation || $translate(`${translationName}.${filter.name}`)"
    variant="solo"
  />
</template>
<script lang="ts">
export default {
    name : "NumberFilter",
    props: {
        translationName: { type: String, required: true },
        filter: { type: Object, required: true },
    },
    emits: ['updateFilters', 'updateFilterState'],
    mounted () {
        this.initSelectedAtStartText()
        this.initUrlQuery()
    },
    methods : {
        initSelectedAtStartText () {
            if (this.filter.initial_value) {
                this.$emit('updateFilterState', {...this.filter, init : false})
                this.$emit('updateFilterState', {...this.filter, init : true, value : this.filter.initial_value})
            }
        },
        initUrlQuery () {
            if (!this.$route.path.includes('formulaire')) {

                const defaultKeys = Object.keys(this.$route.query) // ['type_hydrant']
                defaultKeys.forEach(key => {

                    if (this.filter.name === key) {

                        this.$emit('updateFilterState', {...this.filter, init : false})
                        const values = this.$route.query[key]

                        this.$emit('updateFilterState', {...this.filter, init : true, value : values})
                    }
                })
            }
        },
    }
}
</script>
